var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import React from "react";
var SvgIconJackpot = function SvgIconJackpot(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "47px",
    viewBox: "0 0 22 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-958.000000, -1460.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(928.000000, 1207.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.000000, 253.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.71604938,0 C1.22395062,0 -9.87128075e-13,1.22395062 -9.87128075e-13,2.71604938 L-9.87128075e-13,13.5802469 C-9.87128075e-13,15.0723457 1.22395062,16.2962963 2.71604938,16.2962963 L19.0123457,16.2962963 C20.5044444,16.2962963 21.7283951,15.0723457 21.7283951,13.5802469 L21.7283951,2.71604938 C21.7283951,1.22395062 20.5044444,0 19.0123457,0 L2.71604938,0 Z M2.71604938,1.48148148 L19.0123457,1.48148148 C19.708716,1.48148148 20.2469136,2.01967901 20.2469136,2.71604938 L20.2469136,13.5802469 C20.2469136,14.2766173 19.708716,14.8148148 19.0123457,14.8148148 L2.71604938,14.8148148 C2.01967901,14.8148148 1.48148148,14.2766173 1.48148148,13.5802469 L1.48148148,2.71604938 C1.48148148,2.01967901 2.01967901,1.48148148 2.71604938,1.48148148 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.66666667,
    y: 5.2962963,
    width: 14.2592593,
    height: 2.03703704,
    rx: 1.01851852
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.66666667,
    y: 8.96296296,
    width: 6.11111111,
    height: 2.03703704,
    rx: 1.01851852
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.8148148,
    y: 8.96296296,
    width: 6.11111111,
    height: 2.03703704,
    rx: 1.01851852
  })))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconJackpot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_jackpot.57b0c4ec.svg";
export { ForwardRef as ReactComponent };